import { render, staticRenderFns } from "./acvitateCourse.vue?vue&type=template&id=0cedafdb&scoped=true&"
import script from "./acvitateCourse.vue?vue&type=script&lang=js&"
export * from "./acvitateCourse.vue?vue&type=script&lang=js&"
import style0 from "./acvitateCourse.vue?vue&type=style&index=0&id=0cedafdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cedafdb",
  null
  
)

export default component.exports